import { render, staticRenderFns } from "./footBar.vue?vue&type=template&id=cf7169c2&scoped=true&"
import script from "./footBar.vue?vue&type=script&lang=js&"
export * from "./footBar.vue?vue&type=script&lang=js&"
import style0 from "./footBar.vue?vue&type=style&index=0&id=cf7169c2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../AppPlus/H5/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf7169c2",
  null
  
)

export default component.exports